/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    
    $(document).ready(function() {
        
     /*   
        if($(".nav-primary .menu-item.menu-about-us").length){
            console.log("dela");
            $(".menu-item.menu-about-us").closest($("a")).attr("href", "#");
            
            $('.menu-about-us').closest('a').attr("href", "#");
        }
        $('.menu-item.menu-about-us').closest('a').find('a').attr("href", "#");
        $('.menu-about-us').closest('a').attr("href", "#");
        */
        $('#menu-main-1').children(".menu-item-has-children").children("a").attr('href',"#");
        
        $("#gdpr-checkbox").click(function () {
           if($("#gdpr-checkbox").hasClass('checked')){
                $("#gdpr-checkbox").removeClass('checked');
           }else{
                $("#gdpr-checkbox").addClass('checked');
           }
            
        });
        
        $(".side-post-item").click(function () {

         //   location.hash = "featAnchor";
        });
        
        
        
        
      //$(".pagenav").remove(".page-item-2118");
      //$(".pagenav").remove(".page-item-2108");
        
        if($(".pagenav .page-item-2108").hasClass("current_page_item")){
            $(".pagenav .page-item-1275").addClass("current_page_item");
        }
        if($(".pagenav .page-item-2118").hasClass("current_page_item")){
            $(".pagenav .page-item-1277").addClass("current_page_item");
        }
        $(".pagenav .page-item-2108").remove();
        $(".pagenav .page-item-2118").remove();
        
        if($(".pagenav").hasClass("for-industry")){
            $( "footer" ).addClass( "menu-innovation" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("inhouse-research")){
            $( "footer" ).addClass( "menu-research" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("highlights")){
            $( "footer" ).addClass( "menu-research" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("research")){
            $( "footer" ).addClass( "menu-research" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("sponsored-research")){
            $( "footer" ).addClass( "menu-research" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("news")){
            $( "footer" ).addClass( "menu-media" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("event")){
            $( "footer" ).addClass( "menu-media" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("careers")){
            $( "footer" ).addClass( "menu-opportunities" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        } else if($(".pagenav").hasClass("menu-users")){
            $( "footer" ).addClass( "menu-users" );
            //$( ".pagenav .page_item.page-item-80" ).addClass( "current_page_item" );
        }
        
        
        if ( $( "table" ).length ) {            
            $('table').wrap('<div class="tableWrapper"/>');
            
    }
        
        
        
    });
    
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired

                // Accordion
                var acc = document.getElementsByClassName("accordion");
                var i;

                for (i = 0; i < acc.length; i++) {
                    acc[i].onclick = function () {
                        this.classList.toggle("active");
                        var panel = this.nextElementSibling;
                        if (panel.style.display === "block") {
                            panel.style.display = "none";
                        } else {
                            panel.style.display = "block";
                        }
                    };
                }

                for (i = 0; i < acc.length; i++) {
                    acc[i].onclick = function () {
                        this.classList.toggle("active");
                        var panel = this.nextElementSibling;
                        if (panel.style.maxHeight) {
                            panel.style.maxHeight = null;
                        } else { 
                            panel.style.maxHeight = panel.scrollHeight + "px";
                        }
                    };
                }
                // END Accordion

                //Sub-menu
                $(".menu-item-has-children a").attr("onclick", "return false");
                $(".menu-item-has-children .menu-item a").removeAttr("onclick");


                // Add anchor # to url when you click on a accordion
                $('button.accordion').click(function (e) {
                    var anchLink = "#" + $(this).attr('id');
                  //  console.log(anchLink)
                      //check if #anchor-link already exists
                      if(window.location.hash) {
                        // if so Remove #anchor-link from url
                        var oldUrl = document.location.href; 
                         
                        
                       // console.log("old url with #: " + oldUrl);
                        var index = 0;
                        var fixedUrl = oldUrl;
                        //check if # exists and where it is from the start of url
                        index = oldUrl.indexOf('?');
                      //  console.log("index: " + index);
                        if(index == -1){
                            index = oldUrl.indexOf('#');
                        //    console.log("index: " + index);
                        }
                        if(index != -1){
                            fixedUrl = oldUrl.substring(0, index); //remove old #anchor-link
                            //remove last / in url
                            var lenghtOfUrl = fixedUrl.length;
                         //   console.log("lenghtOfUrl: " + lenghtOfUrl);
                            
                            var to = fixedUrl.lastIndexOf('/');
                        //    console.log("position of last /: " + to);
                            if(to == lenghtOfUrl -1){
                                fixedUrl = fixedUrl.substring(0, to);
                            }
                        }
                     //   console.log("fixed url: " + fixedUrl);
                        var newUrl = fixedUrl+anchLink; //add #achor-link to url
                     //   console.log("url with new #: " + newUrl);
                        history.pushState({}, null, newUrl); // push new url without page reload
                      } else {
                        oldUrl = document.location.href;
                        // remove last / from url
                        to = oldUrl.lastIndexOf('/');
                      //  console.log('to:' + to);
                        oldUrl = oldUrl.substring(0, to);
                    
                      //  console.log("old url: " + oldUrl);

                        var newUrl = oldUrl+anchLink; //add #achor-link to url
                        //document.location = newUrl;
                       // console.log("new url: " + newUrl);
                        history.pushState({}, null, newUrl); // push new url without page reload
                      }
                });


                // check url parameters for anchor links when page loads
                function checkForAnchors(){
                    console.log("checkForAnchors");
                    //first check if # is present
                    if(window.location.hash) {
                        console.log('# is present');
                        console.log(window.location.hash);
                        var anchorLink = window.location.hash;
                        if($(anchorLink).length){
                            $(anchorLink).click();
                            $([document.documentElement, document.body]).animate({
                                scrollTop: $(anchorLink).offset().top-100
                            }, 0);
                        } 
                    }
                }

                $(document).ready(function () {
                checkForAnchors();
                });

                $(window).click(function () {
                    $(".banner .menu-item-has-children").removeClass("activated");
                    $(".sub-menu-background").removeClass("active");
                });
                $(".banner .menu-item-has-children").click(function (e) {
                    e.stopPropagation();
                    $(".sub-menu-background").addClass("active");
                    $(".banner .menu-item-has-children").removeClass("activated");
                    $(this).addClass("activated");
                });
                $(".active").click(function () {
                    $(".sub-menu-background").removeClass("active");
                });

                // Open mobile navigation
                $(".mobile-hamburger").click(function () {
                    if ($("#menu-main-2").hasClass("active") === true) {
                        console.log("1");
                        $("#menu-main-2").removeClass("active");
                        $(".mobile-header").removeClass("active");
                        $(".mobile-brand-logo").removeClass("active");
                        $(".mobile-header.second").removeClass("activated");
                        $(".arrow-left").removeClass("activated");
                        $(".arrow-left").removeClass("blue green orange purple light-blue");
                        $(".mobile-navigation").removeClass("show");
                    } else {
                        $(".mobile-navigation").addClass("show");
                        $("#menu-main-2").addClass("active");
                        $(".mobile-header").addClass("active");
                        $(".mobile-brand-logo").addClass("active");
                        $(".arrow-left").removeClass("activated");
                        $("#menu-main-2 .menu-item-has-children").removeClass("activated");
                        $(".mobile-header.second").addClass("activated");
                    }
                });

                // Mobile navigation 
                $("#menu-main-2 .menu-item-has-children").click(function () {
                    $(this).addClass("activated");
                    $(".arrow-left").addClass("activated");
                    if ($(this).children("a").text() === "About us") {
                        $(".arrow-left").addClass("light-blue");
                    } else if ($(this).children("a").text() === "Users") {
                        $(".arrow-left").addClass("blue");
                    } else if ($(this).children("a").text() === "Industry") {
                        $(".arrow-left").addClass("orange");
                    } else if ($(this).children("a").text() === "Media") {
                        $(".arrow-left").addClass("purple");
                    } else if ($(this).children("a").text() === "Our research") {
                        $(".arrow-left").addClass("light-blue2");
                    } else if ($(this).children("a").text() === "Opportunities") {
                        $(".arrow-left").addClass("light-blue");
                    }
                });
                $(".arrow-left").click(function () {
                    $(this).removeClass("activated");
                    setTimeout(function () {
                        $(".arrow-left").removeClass("blue green orange purple light-blue");
                    }, 300);
                    $("#menu-main-2 .menu-item-has-children").removeClass("activated");
                });

                // Sticky header
                // Hide Header on on scroll down
                var didScroll;
                var lastScrollTop = 0;
                var delta = 5;
                var navbarHeight = $('.mobile-header').outerHeight();

                $(window).scroll(function (event) {
                    didScroll = true;
                });

                function hasScrolled() {
                    var st = $(this).scrollTop();
                    var headerHeight = $(".pagenav").css("height");

                    // Make sure they scroll more than delta
                    if (Math.abs(lastScrollTop - st) <= delta) {
                        return;
                    }
                    // If they scrolled down and are past the navbar, add class .nav-up.
                    // This is necessary so you never see what is "behind" the navbar.
                    if (st + $(window).height() > $(document).height() - 50) {
                        // Scroll to bottom
                        $('.pagenav').removeClass('nav-up');
                        $('.anchor-nav-top').removeClass('nav-up');
                        $('.mobile-header.first').removeClass('nav-up');
                        if ($(".pagenav").css("display") === "block") {
                            $('.anchor-nav-top').css("top", headerHeight);
                        }
                    } else if (st > lastScrollTop && st > navbarHeight) {
                        // Scroll Down
                        $('.pagenav').addClass('nav-up');
                        $('.anchor-nav-top').addClass('nav-up');
                        $('.mobile-header.first').addClass('nav-up');
                        if ($(".pagenav").css("display") === "block") {
                            $('.anchor-nav-top').css("top", "-58px");
                        }
                    } else if (st < 100) {
                        //Scroll to top
                        $('.pagenav').removeClass('nav-up');
                        $('.anchor-nav-top').addClass('nav-up');
                        $('.mobile-header.first').removeClass('nav-up');
                        if ($(".pagenav").css("display") === "block") {
                            $('.anchor-nav-top').css("top", "-58px");
                        }
                    } else if (st + $(window).height() < $(document).height()) {
                        // Scroll Up
                        $('.pagenav').removeClass('nav-up');
                        $('.anchor-nav-top').removeClass('nav-up');
                        $('.mobile-header.first').removeClass('nav-up');
                        if ($(".pagenav").css("display") === "block") {
                            $('.anchor-nav-top').css("top", headerHeight);
                        }
                    }

                    lastScrollTop = st;
                }
                setInterval(function () {
                    if (didScroll) {
                        hasScrolled();
                        didScroll = false;
                    }
                }, 250);

                // END Sticky header

                // Sitemap
                $(".sitemap-btn").click(function () {
                    $("header.banner").addClass("sitemap-active");
                    $(".nav-primary").addClass("close-nav");
                    $(".sitemap-nav").addClass("active");
                    $(this).fadeOut();
                });
                $(".close-map").click(function () {
                    $("header.banner").removeClass("sitemap-active");
                    $(".nav-primary").removeClass("close-nav");
                    $(".sitemap-nav").removeClass("active");
                    $(".sitemap-btn").fadeIn();
                });
                // END Sitemap

                // Anchor scrollspy
                $('body').scrollspy({ target: '#anchor-spy' });
                // END Anchor scrollspy

                // Browse the category
                $('.result-item').hide().filter(function () {
                    return $(this).text().toUpperCase()[0] === "A";
                }).show();

                $('.letter').click(function () {
                    var v = $(this).text()[0];
                    $(".letter").removeClass("active");
                    $(this).addClass("active");
                    $('.result-item').hide().filter(function () {
                        return $(this).text().toUpperCase()[0] === v;
                    }).fadeIn();
                });

                $("#contact-list").find("li").each(function () {
                    var product = $(this);
                    var firstLetter = product.text().toUpperCase()[0];
                    $("#letter-list").find("li").each(function () {
                        var liLetter = $(this);
                        var letter = $(this).text().toUpperCase()[0];
                        if (firstLetter === letter) {
                            liLetter.removeClass("no-data");
                        }
                    });
                });

                // END Browse the category

                // Scrollbar
                //   var ps = new PerfectScrollbar('.perfect-scrollbar');

                // END Scrollbar

                // Page content - check header height for margin
                //Function to the css rule
                function checkSize() {
                    if ($(".pagenav").css("display") === "block") {
                        // your code here
                        var headerHeight = $(".pagenav").css("height");
                        
                        headerHeight = headerHeight.substring(0, headerHeight.length - 2);
                        var strToint = parseInt(headerHeight) + 20;
                        headerHeight = strToint + "px";
                        
                        $(".page-section").css("padding-top", headerHeight);
                    }
                }

                $(document).ready(function () {
                    // run test on initial page load
                    checkSize();

                    // run test on resize of the window
                    $(window).resize(checkSize);
                });
                // END Page content - check header height for margin
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
    
    
    $(".mobile-hamburger1").click(function () {
        $(".mobile-hamburger1").addClass("hide");
        $(".mobile-close1").removeClass("hide");
        $(".mobile-navigation").addClass("show");
    });
    
    $(".mobile-close1").click(function () {
        $(".mobile-close1").addClass("hide");
        $(".mobile-hamburger1").removeClass("hide");
        $(".mobile-navigation").removeClass("show");
    });
    
})(jQuery); // Fully reference jQuery after this point.


